export const BROWSE_GOALS_EVENT_NAMES = {
  CLICKED_TILE: 'Clicked Browse Goal Tile',
  CLICKED_ALIGNED_TILE: 'Clicked Aligned Goal Tile',
  RETURNED_RESULTS: 'Returned Browse Goal Results',
  CLICKED_RELATED_SUBJECT: 'Clicked Browse Results Related Subject',
  SELECTED_SUBJECT: 'Selected Browse Goals Subject',
  SELECTED_GRADE: 'Selected Browse Goals Grade',
  UNSELECTED_GRADE: 'Unselected Browse Goals Grade',
  SELECTED_CATEGORY: 'Selected Browse Goals Category',
  UNSELECTED_CATEGORY: 'Unselected Browse Goals Category',
  CHANGED_LEVEL_OF_SUPPORT: 'Changed Browse Goals Level of Support',
  SELECTED_STANDARD: 'Selected Browse Goals Standard',
  UNSELECTED_STANDARD: 'Unselected Browse Goals Standard',
  SELECTED_CHARACTERISTIC: 'Selected Browse Goals Characteristic',
  SEARCHED_KEYWORD: 'Searched Browse Goals Keyword',
  CLEARED_KEYWORD: 'Cleared Browse Goals Keyword',
  VIEWED_PAGE: 'Viewed Browse Goals Page',
  REMOVED_SUBJECT: 'Removed Browse Goals Subject',
  REMOVED_CATEGORY: 'Removed Browse Goals Category',
  REMOVED_GRADE: 'Removed Browse Goals Grade',
  REMOVED_KEYWORD: 'Removed Browse Goals Keyword',
  REMOVED_STANDARD: 'Removed Browse Goals Standard',
  REMOVED_CHARACTERISTIC: 'Removed Browse Goals Characteristic'
}

export const GOAL_STANDARDS_EVENT_NAMES = {
  CLICKED_STANDARD_ACCORDION: 'Clicked Standard Accordion'
}

export const GOAL_WIZARD_EVENT_NAMES = {
  VIEWED_PAGE: 'Viewed Goal Wizard',
  SUBMITTED: 'Submitted Goal Wizard',
  REQUESTED_CONTENT: 'Content Requested'
}
